import { ChangeEvent, useCallback, useEffect, useMemo, useState } from "react";
import { downloadExcel, downloadSettingExcel } from "src/utils/blob/blobUtil";

import useFetchActionbarAuth from "src/hooks/useFetchActionbarAuth";
import { useLoadingSpinnerStore } from "src/store/util/loadingSpinnerUtil";
import { formatDate, toLocalDateTime, validateString } from "src/utils/string/stringUtil";
import { showError, showSuccess, ShowSuccessFetch, showWarning } from "src/utils/toast/toastUtil";
import { deleteKSK2030_R01, downloadExcel_KSK2030_R01, getKSK2030_R01AllCount, getKSK2030_R01DetailList, getKSK2030_R01List, patchKSK2030_R01, postKSK2030_R01 } from "./Api_KSK2030_R01";
import { defaultKSK2030_R01Dto, KSK2030_R01DetailDto, KSK2030_R01Dto } from "./Dto_KSK2030_R01";
import { defaultKSK2030_R01Filter, KSK2030_R01Filter, useKSK2030_R01Store } from "./Store_KSK2030_R01";
import { AgGridReact } from "ag-grid-react";
import { fetchDataSetHandler, fetchDataSetHandler_refetch, fetchFilterConfig, UpdateRowHandler } from "src/utils/grid/GridHandlerContent";
import useActionbarAuthStore from "src/store/useActionbarAuthStore";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { validateEmployeeCd } from "src/utils/grid/GridValidateContent";


interface OrderContentProps {
	gridRef: React.RefObject<AgGridReact<KSK2030_R01Dto> | null>;
	setMessage: (message: string) => void;  
	
}	


export const Content_KSK2030_R01 = (props: OrderContentProps) => {

	const { 
		gridRef,
		setMessage,
	} = props;

	const {
		KSK2030_R01Filter, setKSK2030_R01Filter,
		KSK2030_R01PastFilter, setKSK2030_R01PastFilter,
		KSK2030_R01List, setKSK2030_R01List, 
		editKSK2030_R01, setEditKSK2030_R01,
		insertKSK2030_R01List, removeKSK2030_R01List,
		deletedKSK2030_R01List, addDeletedKSK2030_R01List, removeDeletedKSK2030_R01List,
		selectedKSK2030_R01, setSelectedKSK2030_R01, initSelectedKSK2030_R01,
		originalKSK2030_R01List, setOriginalKSK2030_R01List,

		KSK2030_R01DetailList, setKSK2030_R01DetailList,
		insertKSK2030_R01DetailList, removeKSK2030_R01DetailList, updateKSK2030_R01DetailList,
		deletedKSK2030_R01DetailList, addDeletedKSK2030_R01DetailList, removeDeletedKSK2030_R01DetailList,
		selectedKSK2030_R01DetailList, setSelectedKSK2030_R01DetailList, initSelectedKSK2030_R01DetailList,
		originalKSK2030_R01DetailList, setOriginalKSK2030_R01DetailList,

		allCount, setAllCount,
		modalVisible, setModalVisible,
		initData,
	} = useKSK2030_R01Store();

	const { setLoadingSpinner } = useLoadingSpinnerStore();
	const { compCdList, downtimeValueList, workPlaceList, jobTeamList, ordTypeList, employeeCdList,  } = useCommonCodeStore();


	const setAuth = useActionbarAuthStore((state) => state.setAuth);



	// 권한 정보 로드
	useFetchActionbarAuth("KSK2030_R01");

	const getParams = (filter: Partial<KSK2030_R01Filter>) => {
		return {
			compCd: filter.compCd,
			workplaceCd: filter.workplaceCd,
			jobTeam: filter.jobTeam,
			dateRange: filter.dateRange,
			closeTag: filter.closeTag,
		}
	}

	const renewalAllCount = useCallback(async () => {
		const response = await getKSK2030_R01AllCount(getParams(KSK2030_R01Filter));
		setAllCount(response.data.data);
		return response.data.data;
	}, [KSK2030_R01Filter, setAllCount]);

	const executeDataFetch = useCallback(async (fetchType: 'search' | 'refetch') => {
		setLoadingSpinner(true);
	
		let initialListLength = KSK2030_R01List.length;
		// 저장 후 재조회 시에는 목록을 비우기.
		if (fetchType === 'refetch') {
			setKSK2030_R01List([]);
		}

		const responseData = await getKSK2030_R01List(
			'',
			getParams(KSK2030_R01Filter),
			fetchType === 'refetch' ? initialListLength : KSK2030_R01List.length ?? 0
		);
	
		let newList = (responseData.data.data as KSK2030_R01Dto[]).map((item) => {
			const orderQty = Number(item.orderQty) || 0;
			const badQty = Number(item.badQty) || 0;
			return {
				...item,
				lossPercent: orderQty > 0 ? (badQty / orderQty) * 100 : 0,
			};
		});
		setKSK2030_R01List(newList);
	
		const processAllCount = await renewalAllCount();
		setOriginalKSK2030_R01List(newList);
		setSelectedKSK2030_R01(undefined);
		setKSK2030_R01DetailList([]);
		removeDeletedKSK2030_R01List(deletedKSK2030_R01List);
		gridRef.current?.api.ensureIndexVisible(0, 'top');
	
		if (newList.length === 0) {
			// insertKSK2030_R01List([{ ...defaultKSK2030_R01Row, inserted: true }], 0);
			showWarning('데이터가 없습니다.');
		} else {
			ShowSuccessFetch(setMessage, `조회가 완료되었습니다. (총 ${newList.length}/${processAllCount}건)`);
		}
	
		setKSK2030_R01PastFilter(KSK2030_R01Filter);
		setLoadingSpinner(false);
	}, [
		KSK2030_R01Filter,  KSK2030_R01PastFilter, KSK2030_R01List, deletedKSK2030_R01List,
		gridRef, setMessage, setLoadingSpinner,
		setOriginalKSK2030_R01List, setSelectedKSK2030_R01, initSelectedKSK2030_R01, insertKSK2030_R01List,
	]);

	/**
	 * 사용자 목록 조회 함수
	 * 검색 조건에 맞는 사용자 목록을 가져옴
	 */
	const fetchData = useCallback(async () => {
		await executeDataFetch('search');
	}, [executeDataFetch]);

	const fetchOne = useCallback(async (data: KSK2030_R01Dto) => {
		setEditKSK2030_R01({
			...defaultKSK2030_R01Dto,
			...data,
			downtimeStartTime: data.downtimeStartTime || toLocalDateTime(new Date()),
			downtimeEndTime: data.downtimeEndTime || toLocalDateTime(new Date()),
			downtimeCase: downtimeValueList[0].minorCd,
		});
	}, []);


	// OrderList가 변경될 때마다 원본 데이터 복사
	useEffect(() => {
		setOriginalKSK2030_R01List(JSON.parse(JSON.stringify(KSK2030_R01List)));
	}, [KSK2030_R01List]);

	// 버튼 비활성화 상태 관리
	const [buttonDisabled, setButtonDisabled] = useState({
		fetch: false,      // 조회: 기본 활성화
		create: false,     // 생성: 기본 활성화
		delete: true,      // 삭제: 기본 비활성화
		save: true,        // 저장: 기본 비활성화
		print: true,       // 출력: 기본 비활성화
		excel: true,       // 엑셀: 기본 비활성화
		init: false        // 초기화: 항상 활성화
	});

	// 선택된 사용자와 삭제된 사용자가 변경될 때 버튼 상태 업데이트
	useEffect(() => {
		setButtonDisabled(prev => ({
			...prev,
			delete: deletedKSK2030_R01List.length === 0 && selectedKSK2030_R01 === null,
			save: KSK2030_R01List.length === 0,
			print: KSK2030_R01List.length === 0,
			excel: KSK2030_R01List.length === 0
		}));
	}, [selectedKSK2030_R01, deletedKSK2030_R01List, KSK2030_R01List]);
	
	/**
	 * 엑셀 다운로드 핸들러
	 * 현재 검색 조건의 사용자 목록을 엑셀 파일로 다운로드
	 */
	const handleExcelClick = useCallback(async () => {

		const response = await downloadExcel_KSK2030_R01(
			'',
			getParams(KSK2030_R01Filter),
			KSK2030_R01List.length ?? 0
		);

		downloadSettingExcel({ responseData: response.data.data, fileName: '작업지시정보등록-excel.xlsx' });
	}, [KSK2030_R01Filter])
	
	//신규 행 추가시 기본적으로 세팅할 데이터를 정하고 생성
	const defaultKSK2030_R01Row = useMemo(() => {

		const workPlaceCdListToUse = workPlaceList.filter(opt => opt.useYn === 'Y' && opt.orderYn === 'Y');

		return {
			...defaultKSK2030_R01Dto,
			compCd: compCdList[0].compCd,
			orderType: ordTypeList[0].minorCd,
			workplaceCd: workPlaceCdListToUse[0].workplaceCd,
			jobTeam: jobTeamList[0].minorCd,
			workProcess: workPlaceCdListToUse[0].workProcess,
			downtimeCase: downtimeValueList[0].minorCd,
			inserted: true
		}
	}, [defaultKSK2030_R01Dto, compCdList, ordTypeList, workPlaceList, jobTeamList]);



	const validateInsertData = (
		data: KSK2030_R01Dto,
	) => {

		let warningMessage = '(지시No 조회필요)';
		
		if (!validateString(data.productResultNo)) {
			showWarning('생산실적번호를 입력해주세요.'); return false;
		}
		if (!validateString(data.compCd)) {
			showWarning('지시정보가 없습니다. 사업장을 선택해주세요.' + warningMessage); return false;
		}
		if (!validateString(data.workplaceCd)) {
			showWarning('공정명을 선택해주세요.' + warningMessage); return false;
		}
		if (!validateString(data.itemCd)) {
			showWarning('품목코드를 입력해주세요.' + warningMessage); return false;
		}
		if (!validateString(data.productEmp)) {
			showWarning('담당자를 입력해주세요.' + warningMessage); return false;
		}
		if (!validateEmployeeCd(data.productEmp, employeeCdList)) {
			showWarning('담당자가 존재하지 않습니다.(입력칸을 더블클릭하거나 엔터키로 세부사항을 열어서 지정해주세요)'); return false;
		}

		//시작시, 종료시는 24 이내
		if (data.downtimeStartHour < 0 || data.downtimeStartHour > 23) {
			showWarning('시작시간은 24 이내여야 합니다.'); return false;
		}
		if (data.downtimeEndHour < 0 || data.downtimeEndHour > 23) {
			showWarning('종료시간은 24 이내여야 합니다.'); return false;
		}

		//시작분, 종료분은 60 이내
		if (data.downtimeStartMinute < 0 || data.downtimeStartMinute > 59) {
			showWarning('시작분은 60 이내여야 합니다.'); return false;
		}
		if (data.downtimeEndMinute < 0 || data.downtimeEndMinute > 59) {
			showWarning('종료분은 60 이내여야 합니다.'); return false;
		}

		//시작시간과 종료시간 조합해서 시-분-초 만들기
		const workStartDt = new Date(data.downtimeStartDt!);
		workStartDt.setHours(data.downtimeStartHour, data.downtimeStartMinute, 0);
		const workEndDt = new Date(data.downtimeEndDt!);
		workEndDt.setHours(data.downtimeEndHour, data.downtimeEndMinute, 0);

		if (workStartDt > workEndDt) {
			showWarning('시작시간은 종료시간보다 이전이어야 합니다.'); return false;
		}

		data.downtimeStartDt = formatDate(workStartDt);
		data.downtimeEndDt = formatDate(workEndDt);

        // 백엔드 전송 시 UTC 변환으로 인한 9시간 차이 보정
        // const kstStartTime = new Date(workStartDt);
        // kstStartTime.setHours(kstStartTime.getHours() + 9);
		// 백엔드 LocalDateTime 형식으로 변환
		data.downtimeStartTime = toLocalDateTime(workStartDt);

        // const kstEndTime = new Date(workEndDt);
        // kstEndTime.setHours(kstEndTime.getHours() + 9);
		data.downtimeEndTime = toLocalDateTime(workEndDt);

		return true;
	}
	
	const handleSaveClick = useCallback(async () => {
		//조회 페이지
		let valid = true;
		if(!validateInsertData(editKSK2030_R01!)) valid = false;
		if(!valid) { return; }

		const postResponse = await postKSK2030_R01({
			...editKSK2030_R01!,
		});

		if(postResponse.data.successFlag) {
			showSuccess('비가동시간 등록에 성공하였습니다.');
			setMessage('비가동시간 등록에 성공하였습니다.');
			setModalVisible(false);
		}else {
			showWarning('비가동시간 등록에 실패하였습니다.');
			return;
		}

		setSelectedKSK2030_R01({...editKSK2030_R01!});
		fetchDetailList(editKSK2030_R01!.productResultNo);

	}, [editKSK2030_R01, setModalVisible, setMessage, selectedKSK2030_R01]);
	
	/**
	 * 삭제 핸들러
	 * 삭제 표시된 행이 있으면 복구, 없으면 선택된 행을 삭제 표시
	 */
	const handleDeleteClick = useCallback(() => {
		//조회 페이지
	}, [selectedKSK2030_R01, deletedKSK2030_R01List, addDeletedKSK2030_R01List, removeDeletedKSK2030_R01List, setKSK2030_R01List, KSK2030_R01List]);


	const fetchDetailList = useCallback(async (productResultNo: string) => {
		try{
			const response = await getKSK2030_R01DetailList(productResultNo);
			if(response.data.successFlag) {
				let newList = [...response.data.data ] as KSK2030_R01DetailDto[];
				setKSK2030_R01DetailList(newList);
			}else {
				showWarning('비가동시간 상세내역 조회에 실패하였습니다.');
				setKSK2030_R01DetailList([]);
				return;
			}

		}catch(error) {
			console.error(error);
			showWarning('비가동시간 상세내역 조회에 실패하였습니다.');
			return;
		}
	}, [KSK2030_R01Filter]);
	

	return{
		handleExcelClick,
		fetchData,
		fetchOne,
		defaultKSK2030_R01Row,
		handleSaveClick,
		handleDeleteClick,
		fetchDetailList,
	}
}
